import logger from '3-foundation/Logging/logger';

export const mapTags = (source: Umbraco.TreeNode[] | Umbraco.TagsCollection): Content.Tags => {
	if (!source) return null;
	try {
		// Handle Tags Collection
		if ('items' in source) {
			const allTags = source.items?.flatMap((item) => item.content?.properties?.items ?? []) as Umbraco.TreeNode[];

			if (!allTags) {
				return { subjectTags: [], statusTags: [], typeTags: [] };
			}

			const subjectTags = allTags.filter((tag) => tag.contentType === 'subjectTag').map((tag) => tag.name);

			const statusTags = allTags.filter((tag) => tag.contentType === 'statusTag').map((tag) => tag.name);

			const typeTags = allTags.filter((tag) => tag.contentType === 'typeTag').map((tag) => tag.name);

			return {
				subjectTags,
				statusTags,
				typeTags,
			};
		}

		// Handle array of TreeNode / Only Subject Tags
		return {
			subjectTags: source.map((node) => node.name),
			statusTags: null,
			typeTags: null,
		};
	} catch (e) {
		const errorMessage = `Could not map tags. \nCause: ${e.message}`;
		logger.error(errorMessage);
		throw new Error(errorMessage, { cause: e });
	}
};
